import Model, { ID, JsonArray, JsonObject } from 'src/models/model'
import RegisterStation from 'src/models/register/RegisterStation'
import Site from 'src/models/site/Site'

export default class PaymentConnectorConfiguration extends Model {
  static name = 'PaymentConnectorConfiguration'

  static deletable = true

  static paginate = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      site: {
        type: Site,
        default: null,
        excludeFromDefault: true,
        output: true
      },
      registerStation: {
        type: RegisterStation,
        default: null,
        output: true
      },
      name: {
        type: String,
        default: ''
      },
      configuration: {
        type: JsonObject,
        default: () => { return {} }
      },
      enabled: {
        type: Boolean,
        default: false
      },
      loggingEnabled: {
        type: Boolean,
        default: false
      },
      transactionOptions: {
        type: JsonArray,
        default: () => { return [] },
        output: true
      },
      computedSiteConfigurationOptions: {
        type: JsonArray,
        default: () => { return [] },
        output: true,
        excludeFromDefault: true
      },
      configurationIgnoreKeys: {
        type: JsonArray,
        default: () => { return [] },
        output: true
      }
    }
  }

  get configurationSummary () {
    return _(this.configuration).keys().map(key => {
      if (this.configurationIgnoreKeys.includes(key)) {
        return null
      } else {
        return { label: _.startCase(key), value: this.configuration[key] }
      }
    }).compact().value()
  }
}
